import { graphql } from 'react-apollo'
import { compose } from 'recompose'

import withLocalization from './withLocalization'
import withFlattenedTranslations from './withFlattenedTranslations'
import withLoadingState from './withLoadingState'
import withErrorState from './withErrorState'
import withRedirectWhenEmpty from './withRedirectWhenEmpty'

import { topicClusterTitleQuery } from '../queries/topicCluster'

export default compose(
  withLocalization,
  graphql(topicClusterTitleQuery, {
    options: ({ language, match, fetchPolicy, stage }) => ({
      variables: {
        topicClusterSlug: match.params.topicClusterSlug,
        lang: language.toLowerCase(),
          stage
      },
      fetchPolicy
    })
  }),
  withErrorState,
  withLoadingState('topicCluster', 'text'),
  withRedirectWhenEmpty('topicCluster'),
  withFlattenedTranslations('topicCluster')
)



// WEBPACK FOOTER //
// ./src/hocs/withTopicCluster.js